module.exports = __webpack_public_path__ + "img/FAV_0064.1e0a319d.jpg";